var _rect, _path, _path2, _path3, _path4, _path5, _path6, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoHat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#EEF2F5",
    stroke: "#FB6E4F",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.038 33.4853V33.4852V27.2117C35.038 26.5458 34.5966 25.9549 33.9502 25.7549C33.015 25.4656 31.8783 25.0958 30.6066 24.643C29.6184 24.2911 28.8383 23.9923 28.1995 23.743C28.0309 23.6773 27.8731 23.6153 27.7245 23.557C27.3061 23.3927 26.9604 23.257 26.6517 23.1448C25.8372 22.8488 25.3343 22.7365 24.5915 22.7513C23.7979 22.7671 23.2924 22.9172 22.5464 23.2249C22.3548 23.3039 22.1465 23.3939 21.9139 23.4943C21.227 23.7909 20.3294 24.1785 19.0338 24.6426L35.038 33.4853ZM35.038 33.4853C35.0381 33.6132 35.0048 33.7443 34.9341 33.8712C34.8631 33.9989 34.7544 34.1217 34.6078 34.2269L34.6076 34.227M35.038 33.4853L34.6076 34.227M34.6076 34.227C33.1133 35.2998 29.5904 37.5 24.5815 37.5C23.5258 37.5 18.8152 37.0718 14.5867 34.2274C14.4297 34.1215 14.3128 33.9954 14.2364 33.8635L13.8067 34.1123M34.6076 34.227L13.8067 34.1123M13.8067 34.1123L14.2364 33.8635C14.1605 33.7323 14.1249 33.5964 14.125 33.464V33.4635M13.8067 34.1123L14.125 33.4635M14.125 33.4635V27.2988M14.125 33.4635V27.2988M14.125 27.2988C14.125 26.6042 14.6067 25.9916 15.2972 25.8075M14.125 27.2988L15.2972 25.8075M15.2972 25.8075C16.5652 25.4693 17.8122 25.0806 19.0337 24.6426L15.2972 25.8075Z",
    fill: "white",
    stroke: "#5283EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5814 30.3534C22.0121 30.3546 19.4625 29.9475 17.0488 29.1507L17.3462 28.4122C19.6646 29.1775 22.1135 29.5685 24.5814 29.5674C27.0493 29.5686 29.4983 29.1775 31.8167 28.4121L32.114 29.1506C29.7004 29.9475 27.1508 30.3546 24.5814 30.3534ZM24.5814 33.8904C22.0121 33.8916 19.4625 33.4845 17.0488 32.6876L17.3462 31.9491C19.6646 32.7145 22.1135 33.1055 24.5814 33.1044C27.0493 33.1055 29.4983 32.7145 31.8167 31.9491L32.114 32.6876C29.7004 33.4845 27.1508 33.8916 24.5814 33.8904Z",
    fill: "#5283EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18C34.9003 18 44 21.5299 44 21.5299C44 21.5299 37.9073 24 25 24C12.0927 24 6 21.5299 6 21.5299C6 21.5299 15.1023 18 25 18Z",
    fill: "#5283EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9987 12C33.9396 12 36.0417 16.4605 35.9994 21C33.455 20.0423 29.9099 19.4653 24.9987 19.4653C20.0874 19.4653 16.5449 20.0567 14.0006 21C13.9583 16.4653 16.0604 12 24.9987 12Z",
    fill: "#5283EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9962 18.6708C28.6954 18.7056 32.382 19.151 36 20L33.9732 11.8812C33.9732 11.8812 29.413 10 25.0704 10C20.7277 10 16.037 11.8812 16.037 11.8812L14 20C17.6156 19.1519 21.2995 18.7066 24.9962 18.6708Z",
    fill: "#5283EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4884 17.8282C32.613 16.8842 28.8833 16 25 16C21.1167 16 17.3947 16.8962 14.5116 17.8282L14 20C17.6168 19.0997 21.3021 18.6274 25 18.59C28.6979 18.627 32.3833 19.0993 36 20L35.4884 17.8282Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40.5607,
    y1: 8.56066,
    x2: 8.56066,
    y2: 40.5607,
    stroke: "#FB6E4F",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHat);
export default __webpack_public_path__ + "static/media/no-hat.209617196d84349158f4cd19dd078a8f.svg";
export { ForwardRef as ReactComponent };